import { reactive, watch } from 'vue';

export const useFormController = ({formContexts, onSubmit}) => {
  
  const state = reactive({
    fields: {},
    data: {}
  });
  
  const getState = () => {
    return state;
  }
  
  const setData = (data) => {
    state.data = data;
    
    Object.keys(state.fields).forEach((key) => {
      setField(key, state.data[key]);
    });
  }
  
  const setField = (key, value) => {
    state.fields[key].model = value;
  }
  
  const hasDelta = () => {
    return Object.keys(calculateDelta()).length !== 0;
  }
  
  const calculateDelta = () => {
    const delta = {};
    
    Object.values(state.fields).forEach((field) => {
      if (field.model !== state.data[field.key]) {
        delta[field.key] = (field.converter) ? field.converter(field.key, field.model) : field.model;
      }
    });
    
    return delta;
  }
  
  const getDelta = () => {
    const delta = calculateDelta();
    
    if (formContexts) {
      formContexts.forEach((context) => {
        delta[context.key] = context.adapter(context.key, delta);
      });
    }
    
    return delta;
  }
  
  const connectField = (key, converter = null) => {
    if (state.fields[key]) {
      return state.fields[key];
    }
    
    const fieldState = reactive({
      key,
      converter,
      model: state.data[key] || null
    });
    
    state.fields[key] = fieldState;
    
    return fieldState;
  }
  
  const doSubmit = () => {
    onSubmit();
  }
  
  return {
    getState,
    setData,
    setField,
    hasDelta,
    getDelta,
    connectField,
    doSubmit
  }
  
}
